// Compact relative-time formatter for room-history sub-lines
// ("just now", "4m ago", "3h ago", "2d ago"). Distinct from Bubble.jsx's
// formatTime(), which renders an absolute wall-clock time for a message.
//
// Returns null for a null/invalid input so callers can fall back to a static
// label (e.g. "private party") rather than printing a bogus time.

const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;

/**
 * @param {number|null|undefined} ts  epoch ms
 * @param {number} [now]              epoch ms (injectable for tests)
 * @returns {string|null}
 */
export function formatRelative(ts, now = Date.now()) {
  if (typeof ts !== 'number' || !Number.isFinite(ts)) return null;
  const diff = now - ts;
  if (diff < 0) return 'just now'; // clock skew — clamp to present
  if (diff < MINUTE) return 'just now';
  if (diff < HOUR) return `${Math.floor(diff / MINUTE)}m ago`;
  if (diff < DAY) return `${Math.floor(diff / HOUR)}h ago`;
  if (diff < WEEK) return `${Math.floor(diff / DAY)}d ago`;
  return `${Math.floor(diff / WEEK)}w ago`;
}

export default formatRelative;
